var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"radio-list flex flex-wrap justify-center items-start pb5 w-100"},_vm._l((_vm.radios),function(radio,index){return _c('radio-card',{key:index,attrs:{"radio":radio}})}),1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea43833a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/localRadios/RadiosList.vue
// module id = 1169
// module chunks = 4